/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccountManagerDeleteResponse } from './AccountManagerDeleteResponse';

export type AccountManagerDeleteResponseApiRespoonse = {
    data?: AccountManagerDeleteResponse;
    status?: AccountManagerDeleteResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AccountManagerDeleteResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

